var modules_51430e0a = {"container":"MenuItem_module_container__2bf8119d","searchContainer":"MenuItem_module_searchContainer__2bf8119d"};
import "../../../assets/DPv3WU4u.css";

export { modules_51430e0a as default };
//# sourceMappingURL=MenuItem.module.less.js.map
